const DLDS01V101 = async () => await import('@/views/dlds/DLDS-01-V101.vue')

export const routerDlds = [
  {
    path: '/dlds/DLDS-01-V101',
    component: DLDS01V101,
    name: 'DLDS-01-V101',
    meta: {
      header: {
        back: false,
        myPage: true,
        refresh: true,
        home: false
      },
      title: '배송현황',
      code: 'DLDS-01-V101',
      tabName: '배송현황'
    }
  }
]
